import {
  Effect,
  createEffect,
  createEvent,
  restore,
  sample,
  createStore,
} from 'effector'
import { persist } from 'effector-storage/local'
import { persist as persistSession } from 'effector-storage/session'

import { UserRole, initUserProfileFx } from '../user'
import { $userRole } from '../user'
import { Request } from '../../libs/request'
import { clearQueue } from '../domain'
import { parseJwt } from '../../libs/parseJWT'
import { role } from '../../libs'
import { dictionariesMounted } from '../dictionaries/model'
import { logout } from '../auth/events'

// События и хранилища для навигации
export const setRedirectPath = createEvent<string>()
export const clearRedirectPath = createEvent()
export const redirectPath = createStore<string | null>(null)
  .on(setRedirectPath, (_, path) => path)
  .reset(clearRedirectPath)

persistSession({
  store: redirectPath,
  key: 'redirectPath',
})

export const appMounted = createEvent()

export const setAccessToken = createEvent<string>()
export const $accessToken = restore(setAccessToken, null)

// sync setting tokens with session storage

persist({
  store: $accessToken,
  key: 'accessToken',
})
$accessToken.on(logout, () => null)

const multipleRequestsFx = createEffect(
  async ({
    payloads,
  }: {
    payloads: {
      fx: Effect<unknown, unknown, unknown>
      params: Request<object>
    }[]
  }) => {
    for (const payload of payloads) {
      await payload.fx(payload.params)
    }
  },
)

sample({
  clock: multipleRequestsFx.done,
  target: clearQueue,
})

//

sample({
  clock: [appMounted, setAccessToken],
  fn: () => ({}),
  target: [initUserProfileFx, dictionariesMounted],
})

// if no tokens - change role

sample({
  clock: [$accessToken],
  source: [$accessToken],
  fn: ([accessToken]) => {
    let roles: UserRole = [role.unauthorized()]
    if (Boolean(accessToken)) {
      let jwt = parseJwt(accessToken)
      roles = jwt.roles
    }
    return roles
  },
  target: $userRole,
})
